import { types } from 'mobx-state-tree';
import { Shape } from './shape-model';

export const TextElement = Shape.named('TextElement')
  .props({
    type: types.optional(types.string, 'text'),
    text: types.optional(types.string, ''),
    placeholder: types.optional(types.string, ''),
    fontSize: types.optional(types.number, 20),
    fontFamily: types.optional(types.string, 'Roboto'),
    fontStyle: types.optional(types.string, 'normal'),
    fontWeight: types.optional(types.union(types.string, types.number), 'normal'),
    textDecoration: types.optional(types.string, ''),
    textTransform: types.optional(types.string, ''),
    fill: types.optional(types.string, '#000000'),
    align: types.optional(types.string, 'center'),
    verticalAlign: types.optional(types.string, 'top'),
    strokeWidth: types.optional(types.number, 0),
    stroke: types.optional(types.string, ''),
    lineHeight: types.optional(types.union(types.number, types.string), 1.2),
    letterSpacing: types.optional(types.number, 0),

    // Text background
    backgroundEnabled: types.optional(types.boolean, false),
    backgroundColor: types.optional(types.string, '#ffffff'),
    backgroundOpacity: types.optional(types.number, 1),
    backgroundCornerRadius: types.optional(types.number, 0),
    backgroundPadding: types.optional(types.number, 0),

    // Curved text
    curveEnabled: types.optional(types.boolean, false),
    curvePower: types.optional(types.number, 0),
  })
  .preProcessSnapshot((snapshot) => {
    if (!snapshot) return snapshot;
    const s = { ...snapshot };

    // Normalize combined fontStyle that may include weight (e.g. "italic bold", "bold")
    if (s.fontStyle && typeof s.fontStyle === 'string') {
      const parts = s.fontStyle.trim().split(/\s+/);
      const styleWords = [];
      const weightWords = [];
      const weightKeywords = ['bold', 'normal', 'lighter', 'bolder',
        '100','200','300','400','500','600','700','800','900'];
      parts.forEach((p) => {
        if (weightKeywords.includes(p)) {
          weightWords.push(p);
        } else {
          styleWords.push(p);
        }
      });
      if (weightWords.length > 0 && !s.fontWeight) {
        s.fontWeight = weightWords[0];
      } else if (weightWords.length > 0 && s.fontWeight === 'normal') {
        s.fontWeight = weightWords[0];
      }
      s.fontStyle = styleWords.length > 0 ? styleWords.join(' ') : 'normal';
    }

    // Coerce numeric fontWeight to string if needed
    if (typeof s.fontWeight === 'number') {
      s.fontWeight = String(s.fontWeight);
    }

    // Coerce text-specific numeric properties from strings
    const numericKeys = [
      'fontSize', 'letterSpacing', 'strokeWidth',
      'backgroundOpacity', 'backgroundCornerRadius', 'backgroundPadding',
      'curvePower',
    ];
    numericKeys.forEach((key) => {
      if (key in s && typeof s[key] === 'string') {
        s[key] = parseFloat(s[key]) || 0;
      }
    });

    // Coerce text-specific boolean properties
    const boolKeys = ['backgroundEnabled', 'curveEnabled'];
    boolKeys.forEach((key) => {
      if (key in s && typeof s[key] === 'string') {
        s[key] = s[key] === 'true';
      }
    });

    return s;
  })
  .volatile(() => ({
    _editModeEnabled: false,
  }))
  .actions((self) => ({
    toggleEditMode(editing) {
      self._editModeEnabled =
        editing !== undefined ? editing : !self._editModeEnabled;
    },
  }));
